
import { useState,useEffect } from "react";
const useFetch = (urls) =>{
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const url = 'https://apiDashboard.agrico.mx/'+urls;
  useEffect(() => {
      fetch(url)
      .then(response => {
        if (!response.ok) { 
          throw Error('No se encontraron datos');
        } 
        return response.json();
      })
      .then(data => {
        setIsLoading(false);
        setData(data);
        setError(null);
      })
      .catch(err => {
        setIsLoading(false);
        setError(err.message);
      })
  }, [url])
  return { data, isLoading, error };
}

export default useFetch;